import styled from '@emotion/styled';
import { pxToRem, theme } from '@vfit/shared/themes';
import { IShadow } from './shadow.models';
import { keyframes } from '@emotion/react';

const shadowLoad = keyframes`
to {
  background-position: 315px 0, 0 0, 0 190px, 50px 195px;
}`;

export const Shadow = styled.div<IShadow>`
  background: linear-gradient(0.25turn, #eeeeee, ${theme.colors.bg.primary}, #eeeeee);
  animation: ${shadowLoad} 1.5s infinite;
  min-height: ${({ height }) => (height ? pxToRem(height) : pxToRem(45))};
  ${({ width }) => (width ? `width : ${width};` : '')}
`;

